// extracted by mini-css-extract-plugin
export default {"principal":"PaginaInicial_principal__XuHtJ","principal__imagem":"PaginaInicial_principal__imagem__LV4Il","galeria":"PaginaInicial_galeria__b5sQ4"};